import React from "react";
import {
  MapStateToProps,
  MapDispatchToProps,
  C_Props,
  MergedProps,
  C_States,
} from "./ResetPassword.type";
import { RootState } from "../../../models";
import { withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import { NotificationActions } from "../../../store/actions";
import { connect } from "react-redux";
import ResetPasswordPresenter from "./ResetPassword.presenter";
class ResetPasswordContainer extends React.Component<MergedProps, C_States> {
  render() {
    return (
      <>
        <ResetPasswordPresenter
          {...this.props}
          {...this.state}
        />
      </>
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(ResetPasswordContainer)
);
